module.exports = __webpack_public_path__ + "static/village_slide_img01-00013bacd831e97b70c876025deacab3.png";